import React from 'react';

const CarouselIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" fill="none" {...props}>
    <g filter="url(#a)">
      <rect width="40" height="40" x="6" y="6" fill="#fff" rx="20" />
      <path fill="#502314" d="m22.795 30.59 4.58-4.59-4.58-4.59 1.41-1.41 6 6-6 6-1.41-1.41Z" />
      <rect width="39" height="39" x="6.5" y="6.5" stroke="#000" strokeOpacity=".3" rx="19.5" />
    </g>
    <defs>
      <filter
        id="a"
        width="52"
        height="52"
        x="0"
        y="0"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_16750_3453" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_16750_3453" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default CarouselIcon;
